import {ReactElement} from 'react';
import Text from '../../common/component/Text';

interface IProps {
  title?: string;
  titleElement?: ReactElement;
  desc?: string;
  className?: string;
  titleClassName?: string;
  descClassName?: string;
  dashedClassName?: string;
}

/*
  TODO : https://github.com/kakaoent/kakaowebtoon-web/pull/838 해당 pr 과 함께 머지될경우 AddedTicketInfoRowV4.tsx 파일과 이 컴포넌트 둘 중 하나만 사용할 예정
*/
export default function DashedInfo({
  title,
  titleElement,
  desc,
  className,
  titleClassName,
  descClassName,
  dashedClassName,
}: IProps) {
  return (
    <div className={cn('flex items-center', className)}>
      {titleElement ?? <Text className={titleClassName}>{title}</Text>}
      <div
        className={cn(
          'flex-1 h-1 border border-b-0 border-dashed',
          dashedClassName
        )}
      />
      <Text className={descClassName}>{desc}</Text>
    </div>
  );
}
